"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueTemplate = void 0;
const Models_1 = require("../../Models/index");
const TemplateUtils_1 = require("./TemplateUtils");
class ValueTemplate {
    static resolve(f) {
        let returnedValue = `${f.name}`;
        if (f.data.type) {
            if (f.data.type === Models_1.Value.EnumValue) {
                returnedValue = `${f.type.name}`;
            }
            if (f.data.type === Models_1.Value.StringValue) {
                returnedValue = `"${f.name}"`;
            }
            if (f.data.type === Models_1.Value.ObjectValue) {
                returnedValue = `{ ${(f.args || []).map((a) => TemplateUtils_1.TemplateUtils.resolverForConnection(a))}}`;
            }
        }
        return returnedValue;
    }
}
exports.ValueTemplate = ValueTemplate;
